import { Box, Grid } from '@mui/material'
import { useQueries } from '@tanstack/react-query'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Loading from 'components/loading'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import WrapperWithHeader from 'components/wrapper-with-header'
import { IProjectDTO } from 'data/dtos/automation/i-project-dto'
import ProjectListCard from 'pages/automation/project/list/card'
import CardSkelleton from 'pages/automation/project/list/card-skelleton'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { loadItem, loadList } from 'services/requests'
import useContract from 'store/contracts'
import extractState from 'utils/organization/extract-state'
import ContractViewHeader from './header'
import { useStyles } from './styles'

interface IRouteParams {
  organizationId: string
  contractId: string
  tagId: string
}

const ContractViewOld = () => {
  const { actualOrganization, updateOrganization, setRollbackUrl, contractTagName } = useContract()
  const { organizationId, contractId, tagId } = useParams<IRouteParams>()

  const classes = useStyles()

  const [organizationQuery, projectsQuery] = useQueries({
    queries: [
      {
        queryKey: ['contracts', 'organization', organizationId],
        queryFn: () => loadItem('/organizations', organizationId),
        enabled: actualOrganization.id == undefined && !!organizationId,
      },
      {
        queryKey: ['contracts', 'list', 'project', organizationId, contractId, tagId],
        queryFn: () =>
          loadList('/projects/list', {
            search: '',
            page: 0,
            rowsPerPage: 100,
            columnOrder: [],
            organizationId: organizationId,
            contractId: contractId,
            tagId: tagId,
          }),
        initialData: { data: { data: [] } } as any,
      },
    ],
  })

  useEffect(() => {
    if (organizationQuery.data && actualOrganization.id == undefined) {
      const organizationState = extractState(organizationQuery.data?.data.data)
      updateOrganization(organizationState)
    }

    if (organizationId && contractId && tagId) {
      setRollbackUrl(`/contract/${organizationId}/${contractId}/${tagId}`)
    }
  }, [organizationQuery.data, organizationId, contractId, tagId])

  if (organizationQuery.isLoading || actualOrganization.id == undefined) {
    return (
      <WrapperWithHeader>
        <Loading />
      </WrapperWithHeader>
    )
  }

  if (projectsQuery.isLoading || projectsQuery.isFetching) {
    return (
      <Wrapper>
        <Header />
        <Page>
          <Box className={classes.container}>
            <Grid
              container
              spacing={3}
              className={classes.itemList}
            >
              <CardSkelleton />
              <CardSkelleton />
              <CardSkelleton />
              <CardSkelleton />
              <CardSkelleton />
              <CardSkelleton />
              <CardSkelleton />
              <CardSkelleton />
            </Grid>
          </Box>
        </Page>
      </Wrapper>
    )
  }

  const projects: IProjectDTO[] = projectsQuery.data?.data.data

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title
          text={contractTagName}
          backRoute={`/contract/${actualOrganization!.id}`}
        />
        <ContractViewHeader project={projects[0]} />
      </Header>

      <Page>
        <Box className={classes.container}>
          <Grid
            container
            spacing={3}
            className={classes.itemList}
          >
            {projects.map((project) => (
              <Grid
                key={project?.id}
                item
                xs={6}
              >
                <ProjectListCard
                  organizationId={organizationId}
                  project={project}
                  contractId={contractId}
                  withoutTags
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Page>
    </Wrapper>
  )
}

export default ContractViewOld
